import useEventsSearch from "../../shared/hooks/useEventsSearch"
import { StateCreator } from "zustand/esm"
import { EventsFilteringStore } from "./useEventsFilteringStore"

export type SearchStoreState = {
  searchTerm?: string
}

export type searchStoreActions = {
  setSearchTerm: (term: string) => void
  clearSearchTerm: () => void
}

const DEFAULT_PROPS: SearchStoreState = {}

type SliceCreator = StateCreator<EventsFilteringStore, [], [], SearchStoreState & searchStoreActions>

export const createSearchSlice: SliceCreator = (set, get, _store) => ({
  ...DEFAULT_PROPS,
  setSearchTerm(searchTerm) {
    useEventsSearch({
      currentSort: get().currentSort,
      searchTerm,
      setLoading: get().setLoading,
    })
  },
  clearSearchTerm() {
    useEventsSearch({
      currentSort: get().currentSort,
      searchTerm: "",
      setLoading: get().setLoading,
    })
  }
})